/**
 * 휴대폰 번호 마스킹 (가운데 4자리)
 * - 01012341234 → 010-****-1234
 * - 형식이 다르면 원본을 최대한 보존
 */
export function maskPhone(mobileno?: string): string {
  const digits = (mobileno ?? "").replace(/\D/g, "");
  if (digits.length !== 11) return mobileno ?? "";
  return digits.replace(/(\d{3})(\d{4})(\d{4})/, "$1-****-$3");
}
